import React from "react";
import LandingImage from "./../../assets/icons/landingbackground.jpeg";
import Logo from "./../../assets/icons/newLogo.svg";
import AccountType from "../../components/landing/accountType";
import { ReactComponent as BusinessLogo } from "./../../assets/icons/Application.svg";
import { ReactComponent as Benefits } from "./../../assets/icons/Benifits.svg";
import { Link } from "react-router-dom";
import YupupScreen from "./../../assets/icons/blackLogo.svg";
import background from "./../../assets/icons/login-new-screen.svg";
import laptop from "./../../assets/icons/laptop-login.svg";

import { colors } from "../../share/constants/enums";
import Button from "../../components/common/button";
import { Divider } from "antd";
import LandingAppLogo from "../../components/common/landingAppLogo";
import BenefitsLandingLogo from "../../components/common/benefitsLandingLogo";

const Landing = () => {
  return (
    <div className="grid h-screen lg:grid-cols-2 lg:gap-4 overflow-y-hidden">
      <div className="hidden lg:block h-screen pt-1 pl-2 rounded-xl relative">
        <img
          src={background}
          alt="bg"
          className="object-cover h-[97%] w-full rounded-xl"
        />
        <img
          src={laptop}
          alt="laptop"
          className="absolute left-[12%] top-[15%] h-[300px] 2xl:left-[25%]"
        />
        <div className="absolute text-white top-[50%] text-center">
          <p className="text-[38px] font-bold ">
            Grow with YupUp: Your Journey to Success Starts Here
          </p>
          <p className="text-center px-3 font-light text-[22px]">
            Join us as an approved vendor on YupUp and experience the power of a
            partnership designed for growth. Together, we’ll amplify your
            business, attract loyal customers, and showcase your best deals. At
            YupUp, we’re not just about transactions—we’re about building
            strong, lasting relationships that fuel your success. Let’s make
            something great happen together!
          </p>
        </div>
      </div>
      <div className="lg:p-8 lg:leading-4 m-auto p-2">
        <img className="h-9" alt="yupup-logo" src={YupupScreen} />
        <p className="text-[25px] lg:text-[34px] font-bold mb-1 mt-2">
          Business Application & Benefits
        </p>
        <p className="font-light text-[14px] lg:text-[18px] mb-4 leading-5">
          Streamline onboarding, showcase services, and expand your reach.
          Partner with us to unlock benefits and grow your business.
        </p>
        <div className="flex gap-2 lg:w-[470px]">
          <Link
            to="/signup"
            className="rounded-md border-solid no-underline border-2 border-[#D8D8D8] group hover:border-none hover:cursor-pointer justify-center hover:bg-[#EBD6FF] flex flex-col items-center lg:w-[220px] h-[140px] w-[160px] lg:h-[170px]"
          >
            {/* <img src={application} alt="img" className="" /> */}
            <LandingAppLogo />
            <p className="group-hover:text-primaryPurple text-black">
              Business Application
            </p>
          </Link>
          <Link
            to="/benefits"
            target="_blank"
            className="rounded-md border-solid no-underline group border-2 border-[#D8D8D8] hover:border-none hover:cursor-pointer hover:bg-[#EBD6FF] justify-center flex flex-col items-center lg:w-[220px] h-[140px] w-[160px] lg:h-[170px]"
          >
            {/* <img src={benefits} alt="img" className="" /> */}
            <BenefitsLandingLogo />
            <p className="group-hover:text-primaryPurple text-black">
              Benefits
            </p>
          </Link>
        </div>
        <div className="py-3 ">
          <Link to={"/login"} className="no-underline">
            <Button
              // loading={loader}
              title="Next"
              color={colors.primaryPurple}
              className="w-full lg:w-[470px] text-[20px]"
            />
          </Link>
        </div>
        <div className="lg:w-[225px] w-16 flex items-center mb-3">
          <Divider />
          <span className="text-black text-opacity-50 px-0.4">or</span>
          <Divider />
        </div>
        <p className="text-[20px] text-black">
          Already have an account?
          <Link to="/login" className="no-underline">
            <span className="text-primaryPurple font-medium ml-1">Login</span>
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Landing;
